import { createTheme } from '@mui/material';

export const theme = createTheme({
  components: {
    MuiAlert: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'alert'
      }
    },
    MuiButton: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'button'
      }
    },
    MuiCard: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'card'
      }
    },
    MuiCheckbox: {
      defaultProps: {
        slotProps: {
          input: {
            // @ts-expect-error - necessary for testing purposes
            'data-component': 'checkbox'
          }
        }
      }
    },
    MuiCircularProgress: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'loader'
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          '&::-webkit-scrollbar': { height: 8, width: 8 },
          '&::-webkit-scrollbar-button': { display: 'none' },
          '&::-webkit-scrollbar-corner': { backgroundColor: 'transparent' },
          '&::-webkit-scrollbar-thumb': {
            backgroundClip: 'content-box',
            backgroundColor: 'rgba(0, 0, 0, 0.35)',
            border: '2px solid transparent',
            borderRadius: 8
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.55)'
          },
          '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
          scrollbarColor: 'rgba(0, 0, 0, 0.35) transparent',
          scrollbarWidth: 'thin'
        },
        '.w-fit-content': {
          width: 'fit-content'
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        cell: {
          '& a': {
            display: 'inline-block',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap'
          }
        },
        root: {
          fontSize: '1rem'
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600
        }
      }
    },
    MuiGrid: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'grid'
      }
    },
    MuiIconButton: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'button'
      }
    },
    MuiLink: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'link'
      }
    },
    MuiMenuItem: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'selectOption'
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'input'
      }
    },
    MuiSelect: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'select'
      }
    },
    MuiStack: {
      defaultProps: {
        useFlexGap: true
      }
    },
    MuiSwitch: {
      defaultProps: {
        slotProps: {
          input: {
            // @ts-expect-error - necessary for testing purposes
            'data-component': 'switch'
          }
        }
      }
    },
    MuiTab: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'tab'
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderBottom: `1px solid ${theme.palette.divider}`
        })
      }
    },
    MuiToggleButton: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'toggleButton'
      }
    },
    MuiTooltip: {
      defaultProps: {
        slotProps: {
          tooltip: {
            // @ts-expect-error - necessary for testing purposes
            'data-component': 'tooltip'
          }
        }
      },
      styleOverrides: {
        arrow: ({ theme }) => ({
          '&::before': {
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)'
          },
          color: theme.palette.common.white
        }),
        tooltip: ({ theme }) => ({
          backgroundColor: theme.palette.common.white,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
          color: theme.palette.carbonGrey.main,
          fontWeight: 400
        })
      }
    },
    MuiTypography: {
      defaultProps: {
        // @ts-expect-error - necessary for testing purposes
        'data-component': 'text'
      }
    }
  },
  palette: {
    // use it to grab light/dark/contrastText:
    // https://mui.com/material-ui/customization/color/#playground
    babysBreath: {
      contrastText: '#000',
      dark: '#979ea2',
      light: '#dfe7ec',
      main: '#D8E2E8'
    },
    barChartAnnexusAndAnnuity: {
      contrastText: '#fff',
      dark: '#5959b2',
      light: '#9999ff',
      main: '#8080ff'
    },
    barChartOtherSavings: {
      contrastText: '#000',
      dark: '#b19a54',
      light: '#fee393',
      main: '#fedd78'
    },
    barChartPlan: {
      contrastText: '#fff',
      dark: '#1c761c',
      light: '#53bb53',
      main: '#28aa28'
    },
    barChartShortfall: {
      contrastText: '#fff',
      dark: '#9a1915',
      light: '#e34f4b',
      main: '#dc241e'
    },
    barChartSocialSecurity: {
      contrastText: '#fff',
      dark: '#3566a1',
      light: '#70a8eb',
      main: '#4d93e6'
    },
    barChartSurplus: {
      contrastText: '#000',
      dark: '#549554',
      light: '#93de93',
      main: '#79d679'
    },
    blue: {
      contrastText: '#fff',
      dark: '#1B4492',
      light: '#6693E4',
      main: '#285BC5'
    },
    carbonGrey: {
      contrastText: '#fff',
      dark: '#3e3e3e',
      light: '#7b7b7b',
      main: '#5A5A5A'
    },
    coral: {
      contrastText: '#fff',
      dark: '#B23047',
      light: '#FF7586',
      main: '#FF405B'
    },
    darkTeal: {
      contrastText: '#fff',
      dark: '#003D56',
      light: '#387C9F',
      main: '#015B7E'
    },
    error: {
      main: '#FF1F3E'
    },
    gold: {
      contrastText: '#fff',
      dark: '#8B6715',
      light: '#D8AF4A',
      main: '#B38C30'
    },
    info: {
      main: '#207182'
    },
    lavender: {
      contrastText: '#000',
      dark: '#7D6AA6',
      light: '#BAA6DC',
      main: '#A689D0'
    },
    lightBlue: {
      contrastText: '#fff',
      dark: '#2998B0',
      light: '#6AD6FF',
      main: '#3BCFF0'
    },
    limeGreen: {
      contrastText: '#000',
      dark: '#35902c',
      light: '#6fd765',
      main: '#4CCE3F'
    },
    maastrichtBlue: {
      contrastText: '#fff',
      dark: '#00131A',
      light: '#395761',
      main: '#012834'
    },
    mistBlue: {
      contrastText: '#000',
      dark: '#D9EDF3',
      light: '#F9FCFD',
      main: '#F4F9FB'
    },
    navyBlue: {
      contrastText: '#fff',
      dark: '#003268',
      light: '#2E73B8',
      main: '#004B8D'
    },
    oliveGreen: {
      contrastText: '#fff',
      dark: '#256E20',
      light: '#5DBC4A',
      main: '#348F2B'
    },
    paleBlue: {
      contrastText: '#000',
      dark: '#A2A7AC',
      light: '#EFF3F8',
      main: '#E8EEF5'
    },
    peach: {
      contrastText: '#000',
      dark: '#E06A4E',
      light: '#FFA890',
      main: '#FD8D62'
    },
    pieChartLow: {
      contrastText: '#fff',
      dark: '#e34f4b',
      light: '#d76d63',
      main: '#dc241e'
    },
    pieChartOk: {
      contrastText: '#000',
      dark: '#a87d04',
      light: '#f3c338',
      main: '#f0b407'
    },
    pieChartSuper: {
      contrastText: '#fff',
      dark: '#1c761c',
      light: '#53bb53',
      main: '#28aa28'
    },
    primary: {
      main: '#005B7E'
    },
    purple: {
      contrastText: '#fff',
      dark: '#4D2884',
      light: '#8C61CC',
      main: '#6736AF'
    },
    richNavy: {
      contrastText: '#fff',
      dark: '#001431',
      light: '#4D607E',
      main: '#001c46'
    },
    seaGreen: {
      contrastText: '#fff',
      dark: '#1E7A64',
      light: '#57C0A8',
      main: '#26A78A'
    },
    secondary: {
      main: '#6837AF'
    },
    sportBlack: {
      contrastText: '#fff',
      dark: '#020202',
      light: '#E8E8E8',
      main: '#141414'
    },
    success: {
      main: '#338F2B'
    },
    teal: {
      contrastText: '#fff',
      dark: '#006C54',
      light: '#33B399',
      main: '#009775'
    },
    violet: {
      contrastText: '#fff',
      dark: '#633E8C',
      light: '#A685DE',
      main: '#8259BD'
    },
    whiteSmoke: {
      contrastText: '#000',
      dark: '#aaaaaa',
      light: '#f6f6f6',
      main: '#F4F4F4'
    },
    yellow: {
      contrastText: '#000',
      dark: '#C79738',
      light: '#FFE27C',
      main: '#FFC845'
    }
  },
  typography: {
    allVariants: {
      color: '#012834'
    },
    body1: {
      fontFamily: 'Source Sans Pro',
      fontSize: '1rem',
      lineHeight: 1.5
    },
    body2: {
      fontFamily: 'Source Sans Pro',
      fontSize: '0.875rem',
      lineHeight: 1.5
    },
    fontSize: 14,
    h1: {
      fontFamily: 'Titillium Web',
      fontSize: '2rem',
      fontWeight: 700,
      lineHeight: 1.2
    },
    h2: {
      fontFamily: 'Titillium Web',
      fontSize: '1.75rem',
      fontWeight: 700,
      lineHeight: 1.3
    },
    h3: {
      fontFamily: 'Titillium Web',
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.3
    },
    h4: {
      fontFamily: 'Titillium Web',
      fontSize: '1.25rem',
      fontWeight: 700,
      lineHeight: 1.4
    },
    h5: {
      fontFamily: 'Titillium Web',
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: 1.5
    },
    h6: {
      fontFamily: 'Titillium Web',
      fontSize: '0.875rem',
      fontWeight: 700,
      lineHeight: 1.5
    },
    htmlFontSize: 16,
    overline: {
      fontFamily: 'Source Sans Pro',
      fontSize: '0.875rem',
      letterSpacing: '0.05em',
      lineHeight: 1.5,
      textTransform: 'uppercase'
    },
    subtitle1: {
      fontFamily: 'Source Sans Pro',
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.5
    },
    subtitle2: {
      fontFamily: 'Source Sans Pro',
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: 1.5
    }
  }
});
